import { RightArrowIcon } from "assets";
import { CustomTooltip } from "components";
import React from "react";

type BreadcrumbItem = {
  group: string;
  root: string;
  active?: boolean;
  onClick?: () => void;
};

type Props = {
  breadcrumbItem: BreadcrumbItem[];
  folders: React.ReactNode;
  addFolderButton: React.ReactNode;
  groupData?: any[];
};

const BreadcrumbFolderLayout: React.FC<Props> = ({
  breadcrumbItem,
  folders,
  addFolderButton,
  groupData,
}) => {
  return (
    <div className="p-4 h-[calc(100vh-2rem)]">
      <div className="bg-white p-6  flex flex-col h-full">
        <header className="text-gray-800 p-4 mb-4">
          <div className="container mx-auto flex justify-between items-center gap-2">
            {/* Breadcrumb Navigation */}
            <nav aria-label="Breadcrumb">
              <ol className="flex flex-wrap items-center gap-2 sm:gap-4">
                {breadcrumbItem.map((items, index) => (
                  <React.Fragment key={index}>
                    {items.active ? (
                      <CustomTooltip
                        title={`Go back to ${items.group}`}
                        placement="bottom"
                      >
                        <li
                          onClick={items.onClick}
                          className={`flex flex-col ${
                            items.active
                              ? "text-primary-900 font-bold"
                              : "text-gray-500 font-bold"
                          } ${
                            items.onClick
                              ? "cursor-pointer hover:text-primary-400"
                              : ""
                          }`}
                        >
                          <span>{items.group}</span>
                          <span
                            className="text-xs leading-tight ps-1"
                            style={{ marginTop: "-7px" }}
                          >
                            {items.root}
                          </span>
                        </li>
                      </CustomTooltip>
                    ) : (
                      <li
                        onClick={items.onClick}
                        className={`flex flex-col ${
                          items.active
                            ? "text-primary-900 font-bold"
                            : "text-gray-500 font-bold"
                        } ${
                          items.onClick
                            ? "cursor-pointer hover:text-primary-400"
                            : ""
                        }`}
                      >
                        <span>{items.group}</span>
                        <span
                          className="text-xs leading-tight ps-1"
                          style={{ marginTop: "-7px" }}
                        >
                          {items.root}
                        </span>
                      </li>
                    )}

                    {index < breadcrumbItem.length - 1 && (
                      <li>
                        <RightArrowIcon className="size-5 font-bold text-gray-500" />
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ol>
            </nav>

            {/* Add Folder Button */}
            <nav>
              <ul className="flex space-x-4 text-sm md:text-base">
                <li>{addFolderButton}</li>
              </ul>
            </nav>
          </div>
        </header>
        <div className="border-t-[1px] border-primary-500 mb-4" />
        {/* Folder Grid */}
        <div className="flex-1 overflow-auto scrollbar-hide mb-6">
          {groupData?.length === 0 ? (
            <div className="text-center text-gray-500 p-10 text-xl">
              <p>Currently no data available.</p>
            </div>
          ) : (
            folders
          )}
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbFolderLayout;
